import './available-times.css'
import {
  Container,
  Col,
  Row
} from "react-bootstrap";
import axios from "axios";
import React, { useState, useEffect } from "react";
import SyncLoader from "react-spinners/SyncLoader";
import TreatmentForm from '../forms/treatment-form';
import DateForm from '../forms/date-form';
import TimeForm from '../forms/time-form';
import {timeConverter} from '../../../clinic-system/view-clinic/modals/time-converter/time-converter';

// import DatePicker from "react-datepicker";
 
import "react-datepicker/dist/react-datepicker.css";
import TimeCard from '../cards/time_card'
// import { LinkContainer } from 'react-router-bootstrap';

export default function AvailableTimes (props) {

  const emirate = props.emirate;
  const [allTimes, setAllTimes] = useState([]);
  const [times, setTimes] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

   const sortTreatment = function (treatment)  {
    let result
    if (treatment === 'All'){
      result = allTimes;
    } else {
      result = allTimes.filter(time => time.title === treatment);
    }
    setTimes(result);
  }

  const findTreatmentsOnDate = function (date)  {
    setLoading(true);
    const start = timeConverter(date.year, date.month, date.day)
    const oneDay = 1 * 24 * 60 * 60 * 1000;
    const end = new Date(start.getTime() + oneDay);
    axios.post("https://uae-dentist-backend.herokuapp.com/schedule/available-times-two-days", {start, end, emirate, requested: false, reserved:false})
    .then((times) => {
        console.log(times.data.bookings);
        setTimes(times.data.bookings);
        setLoading(false);
        console.log('Times Done')
      },
      (error) => {
        setLoading(false);
        setError(error);
      }
    );
  }

  const findTreatmentsOnTime = function (date)  {
    // setLoading(true);
    // const start = timeConverter(date.year, date.month, date.day)
    // const oneDay = 1 * 24 * 60 * 60 * 1000;
    // const end = new Date(start.getTime() + oneDay);
    // axios.post("https://uae-dentist-backend.herokuapp.com/schedule/available-times", {start, end, emirate, requested: false, reserved:false})
    // .then((times) => {
    //     console.log(times.data.bookings);
    //     setTimes(times.data.bookings);
    //     setLoading(false);
    //     console.log('Times Done')
    //   },
    //   (error) => {
    //     setLoading(false);
    //     setError(error);
    //   }
    // );
  }



  useEffect(() => {
    setLoading(true);
    const start = new Date();
    const twoDays = 2 * 24 * 60 * 60 * 1000;
    const end = new Date(start.getTime() + twoDays);
    axios.post("https://uae-dentist-backend.herokuapp.com/schedule/available-times-two-days", {start, end, emirate, requested: false, reserved:false})
    .then((times) => {
        console.log(times.data.bookings);
        setTimes(times.data.bookings);
        setAllTimes(times.data.bookings);
        setLoading(false);
        console.log('Times Done')
      },
      (error) => {
        setLoading(false);
        setError(error);
      }
    );
  }, [emirate]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (loading) {
    return (
      <Container className="my-5" fluid="sm">
        <SyncLoader size={20} margin={3} color={"#123abc"} loading={loading} />
      </Container>
    );
  } else {
        return (
          <Col className='justify-content-end' sm={12} md={12} lg={12}>
            <Row className='my-3'>
              <Col>
              <TreatmentForm sortTreatment={sortTreatment} />
              </Col>
              <Col>
              <TimeForm findTreatmentsOnTime={findTreatmentsOnTime} />
              </Col>
              <Col>
              <DateForm findTreatmentsOnDate={findTreatmentsOnDate} />
              </Col>
            </Row>
            <Row>
              <TimeCard times={times}/>
            </Row>
          </Col>
        );
      }
  }
    